import React from 'react';
import PropTypes from 'prop-types';
import _kebabCase from 'lodash/kebabCase';
import _isString from 'lodash/isString';

import BEM from 'components/utils/BEM';

const FormLabel = ({ children, className, htmlFor }) => (
  <label
    className={BEM('form__label').mix(className)}
    data-test={_isString(children) ? `${_kebabCase(children)}-label` : ''}
    htmlFor={htmlFor}
  >
    {children}
  </label>
);

FormLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  htmlFor: PropTypes.string,
};

FormLabel.defaultProps = {
  children: null,
  className: '',
  htmlFor: '',
};

export default FormLabel;
